export default "__VITE_ASSET__CdWwGNQV__"